import React from "react";
import PropTypes from "prop-types";

/**
 * ChatWidgetLauncher
 * ---------------------------------------------------------------------------
 * The floating action button (FAB) that lives bottom-right of the page.
 * Purely presentational: all state lives in useChatWidgetState and is
 * passed down as props from ChatWidgetContainer.
 */
export default function ChatWidgetLauncher({
  isOpen,
  unreadCount = 0,
  onToggle,
  launcherRef,
  size = 60,
  variant = "Round Blue",
}) {
  return (
    <button
      type="button"
      ref={launcherRef}
      className={`cbai-launcher cbai-launcher--${String(variant || "Round Blue").toLowerCase().replace(/\s+/g, "-")}`}
      style={{ width: size, height: size }}
      aria-label={isOpen ? "Close chat" : "Open chat"}
      aria-expanded={isOpen}
      aria-controls="cbai-widget-panel"
      onClick={onToggle}
    >
      <span className="cbai-launcher__icon" aria-hidden="true">
        {isOpen ? (
          // Close (X) icon
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M6 6l12 12M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
            />
          </svg>
        ) : (
          // Chat bubble icon
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8A2.5 2.5 0 0 1 17.5 16H10l-4.2 3.4a.6.6 0 0 1-.98-.47V16h-.32A2.5 2.5 0 0 1 4 13.5v-8Z"
              fill="currentColor"
            />
          </svg>
        )}
      </span>

      {!isOpen && unreadCount > 0 && (
        <span className="cbai-launcher__badge" aria-hidden="true">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
      <span className="visually-hidden">
        {unreadCount > 0 && !isOpen
          ? `${unreadCount} unread message${unreadCount > 1 ? "s" : ""}`
          : ""}
      </span>
    </button>
  );
}

ChatWidgetLauncher.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  unreadCount: PropTypes.number,
  onToggle: PropTypes.func.isRequired,
  launcherRef: PropTypes.shape({ current: PropTypes.any }),
  size: PropTypes.number,
  variant: PropTypes.string,
};
